import api from "./api/client";

/**
 * GET /freight/transport-queues/summary
 * Retorna fretes elegíveis + filas de transportadoras agregadas.
 */
export async function fetchTransportQueueHubSummary(params = {}) {
  const response = await api.get("/freight/transport-queues/summary", {
    params,
  });
  return response?.data?.data ?? response?.data ?? {};
}

/**
 * POST /freight/{freightId}/transport-queue/accept
 * Aceita uma transportadora da fila e atribui ao frete.
 */
export async function acceptTransportQueueHubCandidate({
  freightId,
  idCarrier,
  nameCarrier,
  idUser,
}) {
  const response = await api.post(`/freight/${freightId}/transport-queue/accept`, {
    idCarrier,
    nameCarrier,
    idUser,
  });
  return response?.data?.data ?? response?.data ?? {};
}
